import { useKeyboardShortcut } from '@/features/canvas/engine/hooks/use-keyboard-shortcut';

export interface UndoRedoApi {
  undo: () => void;
  redo: () => void;
}

export function useUndoRedoShortcut(api: UndoRedoApi) {
  useKeyboardShortcut(
    { key: 'z', meta: true },
    (e) => {
      e.preventDefault();
      if (e.shiftKey) {
        api.redo();
      } else {
        api.undo();
      }
    },
  );
}
